import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Loader, NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { BnNgIdleService } from 'bn-ng-idle';


@Component({
  selector: 'app-epc-dashboard',
  templateUrl: './epc-dashboard.component.html',
  styleUrls: ['./epc-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class EpcDashboardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();
  totalEpcUser: any;
  totalEpcDevices: any;
  activeEpcDevices: any;
  inactiveEpcDevices: any;
  resultObject: any = {};
  totalEpcSolarCapacity: any;
  totalEpcEnergyGenerated: any;
  loaders: any[];
  @Input() loader: Loader;
  co2EmmisionSavedEpc: any;
  dataOfUser: any;
  userCount: any;
  search: any = '';
  offset: any = 0;
  limit: any = 20;
  page = 1;

  constructor(private bnIdle: BnNgIdleService, private ngxUiLoaderService: NgxUiLoaderService, private dashboardService: DashboardService, private toastr: ToastrService, private router: Router,) {
    this.loaders = [
      {
        // hasProgressBar: true,
        loaderId: 'loader-00',
        // logoUrl: LOGO_URL,
        logoSize: 80,
        isMaster: true,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used

        // hasProgressBar: true,
        loaderId: 'loader-01',
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used
        // hasProgressBar: true,
        loaderId: 'loader-02',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        // hasProgressBar: true,
        loaderId: 'loader-03',
        // logoUrl: LOGO_URL,

        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      { // used
        // hasProgressBar: true,
        loaderId: 'loader-04',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-05',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-06',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-07',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-08',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-09',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-10',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-11',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-12',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-13',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-14',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-15',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-16',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-17',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-18',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
      {
        // hasProgressBar: false,
        loaderId: 'loader-19',
        // isMaster: false,
        spinnerType: SPINNER.ballScaleMultiple,
        // overlayColor: '#ffffff00',
        // blur: 0
      },
    ];



  }




  ngOnInit() {
    this.getEpcDashboardData();
    this.getEpcDashboardDataInfo();
    this.totalEnergyGeneratedEPC();
    this.getDeviceDataOfAllUser(this.search, this.limit, this.offset);
    this.searchEpcUsers();
    // auto call after two min is not active user calulate in second
    this.bnIdle.startWatching(900).subscribe((res) => {
      if (res) {
        this.getEpcDashboardData();
        this.getEpcDashboardDataInfo();
        this.totalEnergyGeneratedEPC();
      }
    });
  }
  // EPC dashboard api call
  getEpcDashboardData() {
    this.dashboardService.getDashboardData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.resultObject = result.resultObject.dashboardCount;
            this.totalEpcUser = this.resultObject.totalusers;
            this.totalEpcDevices = this.resultObject.totaldevices;
            this.activeEpcDevices = this.resultObject.activedevices;
            this.inactiveEpcDevices = this.resultObject.inactivedevices;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.error(result.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  getEpcDashboardDataInfo() {
    this.dashboardService.getDashboardDataInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.totalEpcSolarCapacity = result.resultObject.totalSolarCapacity;
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  totalEnergyGeneratedEPC() {
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[3].loaderId);
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[4].loaderId);
    this.dashboardService.totalEnergyGeneratedEPC()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.totalEpcEnergyGenerated = result.resultObject.totalEnergyGenerated;
            this.co2EmmisionSavedEpc = result.resultObject.co2EmmisionSaved;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[4].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[3].loaderId);
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[4].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  getDeviceDataOfAllUser(search, limit, offset) {
    if (offset === 0) {
      this.page = 1;
    }
    this.dataOfUser = [];
    this.ngxUiLoaderService.startBackgroundLoader(this.loaders[5].loaderId);
    var deviceObj = {
      search,
      limit,
      offset,
      role: 0,
    };
    this.dashboardService.getDeviceDataOfUser(deviceObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async result => {
          if (result.status) {
            this.userCount = result.count;
            this.dataOfUser = result.resultObject;
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[5].loaderId);
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(result.message);
            }
            this.ngxUiLoaderService.stopBackgroundLoader(this.loaders[5].loaderId);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  viewPortalUserEpc(frm) {
    const loginObj = {
      user_id: frm,
      isview: true
    };
    this.dashboardService.loginViewPortalEpc(loginObj)
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            localStorage.setItem('loginToken', data.resultObject.token);
            localStorage.setItem('role', data.resultObject.role);
            localStorage.setItem('name', data.resultObject.name);
            localStorage.setItem('id', data.resultObject.id);
            localStorage.setItem('login_id', data.resultObject.login_id);
            localStorage.setItem('logo', data.resultObject.logo);
            localStorage.setItem('company_name', data.resultObject.company_name);
            localStorage.setItem('epc_id', data.resultObject.epc_id);
            localStorage.setItem('isview', data.isview);
            localStorage.setItem('admin_id', data.resultObject.admin_id);
            localStorage.setItem('through', 'epc');
            localStorage.setItem('SadminAccess', JSON.stringify(data.resultObject.SadminAccess) || '[]');
            localStorage.setItem('is_emeter', data.resultObject.is_emeter);
            localStorage.setItem('is_wms', data.resultObject.is_wms);
            window.location.reload();
          } else if (!data.status) {
            if (data.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPage(pageIndex): void {
    this.offset = (pageIndex - 1) * this.limit;
    this.getDeviceDataOfAllUser(this.search, this.limit, this.offset);
  }

  onSearch(event: KeyboardEvent) {
    this.searchSubject.next((event.target as HTMLInputElement).value.trim());
  }

  searchEpcUsers() {
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        this.offset = 0;
        this.search = searchValue;
        this.getDeviceDataOfAllUser(this.search, this.limit, this.offset);
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.bnIdle.stopTimer();
    this.destroy$.next();
    this.destroy$.complete();
    this.searchSubject.next();
    this.searchSubject.complete();
  }

}
